import useAccountManagementStore from "../../stores/accountManagementStore";
import useDataStore, { dataStoreDefaultData } from "../../stores/dataStore";
import useMainStore, {
    defaultData as mainStoreDefaultData,
} from "../../stores/mainStore";
import useSettingsStore, {
    settingsStoreDefaultData,
} from "../../stores/settingsStore";
import useTextFilesStore from "../../stores/textFilesStore";
import removeTableData from "../backend/table_database/removeTableData";
import { saveDataStore } from "./manageDataStore";
import { saveMainStore } from "./manageMainStore";

export async function ClearSoftwareData(clearCloudData: boolean) {
    const userID = useAccountManagementStore.getState().userData?.id;
    const noteIDs = Object.keys(useDataStore.getState().data.notes);
    const folderIDs = Object.keys(useDataStore.getState().data.folders);

    useTextFilesStore.getState().clearTextFiles(true);
    useMainStore.getState().set.data((prev) => {
        return { ...mainStoreDefaultData, loaded: true, userID: userID };
    });
    useDataStore.getState().set.data((prev) => dataStoreDefaultData);
    useSettingsStore.getState().set.data((prev) => settingsStoreDefaultData);

    saveDataStore(userID);
    saveMainStore(userID);

    // if (reloadPage) window.location.reload();

    const userData = useAccountManagementStore.getState().userData;

    if (clearCloudData && userData?.id && userData.id !== "default") {
        // Remove all Folders and Notes from cloud
        removeTableData({
            deletedData: { notes: noteIDs, folders: folderIDs },
            resetDeleted: true,
        });
    }
}
